var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1042 4.62699H8.79017C8.5695 4.62699 8.36283 4.51766 8.23883 4.33499L7.30217 2.95833C7.17817 2.77633 6.97217 2.66699 6.7515 2.66699H3.77083C3.03417 2.66699 2.4375 3.26366 2.4375 4.00033V12.0003C2.4375 12.737 3.03417 13.3337 3.77083 13.3337H13.1042C13.8408 13.3337 14.4375 12.737 14.4375 12.0003V5.96033C14.4375 5.22433 13.8408 4.62699 13.1042 4.62699Z",
    stroke: "#001A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClose);
export default __webpack_public_path__ + "static/media/folder-close.a813a365a45d2ec0bae02c622282605d.svg";
export { ForwardRef as ReactComponent };